/**
 * Avatar component for users/groups in conversations.
 * @param {{ label: string, group?: boolean }} props
 */
export function Avatar({ label, group = false }) {
  const initials =
    label
      ?.split(' ')
      .map((word) => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2) || '?';

  return (
    <div className={`responder-messenger-avatar${group ? ' is-group' : ''}`}>
      <span>{initials}</span>
    </div>
  );
}
